module.exports = __webpack_public_path__ + "img/fillter.d7e25473.svg";